export const FORBIDDEN_FIELD_KEYS = [
  'video',
  'image',
  'images',
  'photo',
  'framePixels',
  'jpeg',
  'png',
  'email',
  'name',
  'phone',
] as const;

const FORBIDDEN = new Set<string>(FORBIDDEN_FIELD_KEYS);
const MAX_DEPTH = 40;

function isForbiddenKey(key: string): boolean {
  return FORBIDDEN.has(key) || FORBIDDEN.has(key.toLowerCase());
}

/**
 * Returns the dotted path of the first forbidden key, or null.
 * Walks objects and arrays; skips cycles.
 */
export function findForbiddenField(
  value: unknown,
  path = '',
  seen: WeakSet<object> = new WeakSet(),
  depth = 0
): string | null {
  if (value === null || typeof value !== 'object' || depth > MAX_DEPTH) {
    return null;
  }
  if (seen.has(value)) {
    return null;
  }
  seen.add(value);

  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i += 1) {
      const nextPath = path ? `${path}[${String(i)}]` : `[${String(i)}]`;
      const found = findForbiddenField(value[i], nextPath, seen, depth + 1);
      if (found) {
        return found;
      }
    }
    return null;
  }

  const record = value as Record<string, unknown>;
  for (const key of Object.keys(record)) {
    const nextPath = path ? `${path}.${key}` : key;
    if (isForbiddenKey(key)) {
      return nextPath;
    }
    const found = findForbiddenField(record[key], nextPath, seen, depth + 1);
    if (found) {
      return found;
    }
  }
  return null;
}
